import Vue from "vue";
import VueMeta from "vue-meta";
import VueRouter, { RouteConfig } from "vue-router";

import auth from "@/modules/auth/routes";
import home from "@/modules/home/routes";
import settings from "@/modules/settings/routes";
import externals from "@/modules/externals/routes";
import activation from "@/modules/activation/routes";
import middleware from "@/router/middleware/auth";
import store from '@/store';

Vue.use(VueRouter);

//Register meta tag manager
Vue.use(VueMeta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});

const routes: Array<RouteConfig> = [
  {
    path: '/logout',
    name: 'logout',
    meta: {
			guest: true,
		},
    beforeEnter: async (to, from, next) => {
      try {        
        console.error("Logout page App:");
        await store.dispatch('auth/logout');        
        next({ name: 'login' });
      } catch (error) {
        console.error("Logout failed:", error);
        next(false);  // Prevent navigation if logout fails
      }
    },
  },
  ...auth,
  ...home,
  ...settings,
  ...activation,
  ...externals,
];

const router = new VueRouter({
  mode: "history",
  routes,
});

//Use middlewares
router.beforeEach(middleware);

export default router;
